/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EligibilityCheckProviderInfo
 */
export interface EligibilityCheckProviderInfo {
    /**
     * National Provider Identifier
     * @type {string}
     * @memberof EligibilityCheckProviderInfo
     */
    npi?: string;
    /**
     * Last name of the provider (Community name)
     * @type {string}
     * @memberof EligibilityCheckProviderInfo
     */
    lastName?: string;
    /**
     * Organization or facility name for facility-based requests
     * @type {string}
     * @memberof EligibilityCheckProviderInfo
     */
    organizationName?: string;
}

/**
 * Check if a given object implements the EligibilityCheckProviderInfo interface.
 */
export function instanceOfEligibilityCheckProviderInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EligibilityCheckProviderInfoFromJSON(json: any): EligibilityCheckProviderInfo {
    return EligibilityCheckProviderInfoFromJSONTyped(json, false);
}

export function EligibilityCheckProviderInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityCheckProviderInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'npi': !exists(json, 'npi') ? undefined : json['npi'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'organizationName': !exists(json, 'organizationName') ? undefined : json['organizationName'],
    };
}

export function EligibilityCheckProviderInfoToJSON(value?: EligibilityCheckProviderInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'npi': value.npi,
        'lastName': value.lastName,
        'organizationName': value.organizationName,
    };
}

